<template>
	<div>
		<div class="social-login" v-if="!inApp">
			<div class="title_s">הצטרפות לכרמלה באמצעות:</div>
			<div class="inline clearfix">
				<div class="right soc_bt soc_g ease">
					<a href="#" @click.prevent="googleLogin">
						Google
						<GOOGLE />
					</a>
				</div>
				<div class="right soc_bt soc_face ease">
					<a href="#" @click.prevent="facebookLogin">
						Facebook
						<FACEBOOK />
					</a>
				</div>
			</div>
			<div class="login_note">
				הצטרפות מהירה דרך רשתות חברתיות - קל, בטוח והכי חשוב – לא צריך לזכור סיסמה! (לא לדאוג, לעולם לא נפרסם
				משהו ללא הסכמתך)
			</div>
			<div class="row_or">
				<span>או</span>
			</div>
		</div>
		<div class="title_s">להצטרפות באמצעות מייל</div>
		<div class="register_form">
			<form method="post" class="regForm" novalidate @submit.prevent="register($event)">
				<div class="form_row clearfix">
					<div class="right form_input">
						<input
							type="text"
							id="regForm_firstname"
							name="firstname"
							v-validate="{ required: true }"
							placeholder="שם פרטי*"
						/>
						<div class="error_tx">{{ errors.first("firstname") }}</div>
					</div>
					<div class="left form_input">
						<input
							type="text"
							id="regForm_lastname"
							name="lastname"
							v-validate="{ required: true }"
							placeholder="שם משפחה*"
						/>
						<div class="error_tx">{{ errors.first("lastname") }}</div>
					</div>
				</div>
				<div class="form_input">
					<input
						type="text"
						id="regForm_email"
						name="email"
						v-validate="'required|email'"
						v-model="email"
						placeholder="מייל*"
					/>
					<div class="error_tx">{{ errors.first("email") }}</div>
				</div>
				<div class="form_input">
					<input
						type="text"
						id="regForm_emailconf"
						name="emailconf"
						v-validate="{ required: true, email: true, is: email }"
						placeholder="ועוד פעם מייל*"
					/>
					<div class="error_tx">{{ errors.first("emailconf") }}</div>
				</div>
				<div class="form_input">
					<input
						type="password"
						id="regForm_password"
						name="password"
						v-validate="'required|min:6'"
						placeholder="סיסמה*"
					/>
					<div class="error_tx">{{ errors.first("password") }}</div>
				</div>
				<div class="error_tx" v-if="error">{{ error }}</div>
				<!-- <div class="form_check">
          <label class="form_check_tx">
            קראתי ואישרתי את
            <a-div :force-new="true" :href="wpData.terms_page">תנאי שימוש</a-div>
            <input type="checkbox" name="terms" v-validate="'required'" value="קראתי ואישרתי את תנאי השימוש">
            <span class="checkmark"></span>
          </label>
          <div class="error_tx">{{ errors.first("terms") }}</div>
        </div> -->
				<div class="form_check">
					<label class="form_check_tx">
						אני רוצה לקבל עדכונים לגבי מבצעים והפתעות עונתיות במייל וב-sms
						<input
							type="checkbox"
							name="subscribe"
							checked
							value="1"
						/>
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="submit_bt ease">
					<input type="submit" value="הצטרפות לכרמלה" />
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import FACEBOOK from "../../assets/img/soc_face.svg";
	import GOOGLE from "../../assets/img/soc_g.svg";
	import axios from "axios";

	export default {
		data() {
			return {
				email: "",
				error: "",
				page: "",
				wpData: wpData,
				inApp: this.$store.state.inApp
			};
		},
		methods: {
			googleLogin() {
				var _this = this;
				// Ideally the button should only show up after gapi.client.init finishes, so that this
				// handler won't be called before OAuth is initialized.
				gapi.auth2
					.getAuthInstance()
					.signIn()
					.then(res => {
						if (res) {
							let id_token = res.getAuthResponse().id_token;
							let form = new FormData();
							form.append("id_token", id_token);
							axios({
								method: "POST",
								url: homeUrl + "?googleReg",
								headers: {
									"X-Requested-With": "XMLHttpRequest"
								},
								data: form
							}).then(response => {
								if (response.data.success == "false") {
									_this.error = response.data.errorText;
									return;
								}
								if (response.data.success == "true") {
									_this.$store.commit("setUserInfo", response.data.userInfo);
                  _this.send_tag("google", response.data.userInfo.id);
									_this.$modal.hide("login-modal");
									if (_this.$route.name == "perm_page_new") {
										_this.$router.push("/my-account/permenant");
									}
									if (_this.$route.name == "orderEnter") {
										_this.$router.push("/checkout");
									}
								}
							});
						}
					});
			},
			facebookLogin() {
				var _this = this;
				FB.login(
					function(response) {
						// Handle the response object, like in statusChangeCallback() in our demo
						// code.
						let token = response.authResponse.accessToken;
						let userId = response.authResponse.userID;
						let form = new FormData();
						form.append("token", token);
						form.append("userID", userId);
						axios({
							method: "POST",
							url: homeUrl + "?facebookReg",
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							},
							data: form
						}).then(res => {
							if (res.data.success == "false") {
								_this.error = res.data.errorText;
								return;
							}
							if (res.data.success == "true") {
								_this.$store.commit("setUserInfo", res.data.userInfo);
                _this.send_tag("facebook", response.data.userInfo.id);
								_this.$modal.hide("login-modal");
								if (_this.$route.name == "perm_page_new") {
									_this.$router.push("/my-account/permenant");
								}
								if (_this.$route.name == "orderEnter") {
									_this.$router.push("/checkout");
								}
							}
							/*_this.$ajax.get(ajaxUrl + "?action=isUserLogged").then(resposne => {
	                 if (resposne.data.success) {
	                   var user = resposne.data.data;
	                   _this.$store.commit("setUserInfo", user);
	                 } else {
	                   _this.$store.commit("clearUser");
	                 }
	               });*/
						});
					},
					{ scope: "email" }
				);
			},
			register(event) {
				this.$validator.validate().then(result => {
					if (result) {
						//  var formData = $(event.currentTarget).serialize();
						var formData = document.querySelector(".regForm");
						var data = new FormData(formData);
						this.$ajax({
							method: "POST",
							url: homeUrl + "?sendReg",
							resType: "json",
							data: data,
							headers: {
								"X-Requested-With": "XMLHttpRequest"
							}
						}).then(response => {
							if (response.data.success == "false") {
								this.error = response.data.errorText;
								return;
							}
							if (response.data.success == "true") {
								this.$store.commit("setUserInfo", response.data.userInfo);
								this.$modal.hide("login-modal");
								this.send_tag("website", response.data.userInfo.id);
								if (this.$route.name == "perm_page_new") {
									this.$router.push("/my-account/permenant");
								}
							}
						});
					}
				});
			},
			send_tag(method, new_wp_user_id) {
				const dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "sign_up",
					method: method,
					new_wp_user_id: new_wp_user_id,
					in_checkout: "no"
				});
			}
		},
		mounted() {
			/*this.$ajax
	                 .get(homeUrl + "wp-json/wp/v2/pages/48")
	                 .then(response => (this.page = response.data));*/
		},
		computed: {
			termsURL: function() {
				return decodeURI(this.page.slug);
			}
		},
		components: {
			FACEBOOK,
			GOOGLE
		}
	};
</script>

<style scoped></style>
